import { render, staticRenderFns } from "./SearchResultsBodyPWA.vue?vue&type=template&id=7d652cd8&scoped=true"
import script from "./SearchResultsBodyPWA.vue?vue&type=script&lang=js"
export * from "./SearchResultsBodyPWA.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsBodyPWA.vue?vue&type=style&index=0&id=7d652cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d652cd8",
  null
  
)

export default component.exports